module.exports = __webpack_public_path__ + "img/planta-mobile@2x.de9d4ce7.png";